<template>
	<div>
		<div class="container">
			<div class="row">
				<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0">
					<div class="form--v10 px-3 py-4 rounded--11 bg-color--light--2">
						<div class="container">
							<h4 class="text-center pb-4">جزییات قرارداد</h4>
							<!-- ====== supplier_name &  net_amount ===========-->
							<div class="row justify-content-between">
								<!--   supplier_name   -->
								<div class="col-md-5">
									<div>
										<label class="form__label font-size--15 font-w--500">{{
											$t("contract.supplier_name") + " : "
										}}</label>
										<label
											class="form__label text-uppercase font-size--15 font-w--400"
											>{{ "  " + supplier_name }}</label
										>
									</div>
								</div>
								<!--   net_amount   -->
								<div class="col-md-6">
									<div class="form-group">
										<label class="form__label font-size--15 font-w--500">{{
											$t("contract.net_amount") + "  :  "
										}}</label>
										<vue-numeric
											id="net_amount"
											separator=","
											v-model="net_amount"
											class="form-control"
											read-only
										></vue-numeric>
										<label class="form__label font-size--15 font-w--400"
											>{{ "&nbsp;" + $t("contract.rial") }} &nbsp;</label
										>
									</div>
								</div>
							</div>

							<!-- ====== downpayment &  number_of_instalment ===========-->
							<div class="row justify-content-between">
								<!--   downpayment   -->
								<div class="col-md-6">
									<div>
										<label class="form__label font-size--15 font-w--500">{{
											$t("contract.downpayment") + "  :  "
										}}</label>
										<vue-numeric
											id="downpayment"
											separator=","
											v-model="downpayment"
											class="form-control"
											read-only
										></vue-numeric>
										<label class="form__label font-size--15 font-w--400"
											>{{ "&nbsp;" + $t("contract.rial") }} &nbsp;</label
										>
									</div>
								</div>
								<!--   number_of_instalment   -->
								<div class="col-md-6">
									<div class="form-group">
										<label class="form__label font-size--15 font-w--500"
											>{{
												$t("contract.number_of_instalment")
											}}
											&nbsp;:&nbsp;</label
										>
										<label
											class="form__label text-uppercase font-size--15 font-w--400"
											>&nbsp;{{ number_of_instalment }}&nbsp;</label
										>
										<label
											class="form__label text-uppercase font-size--15 font-w--400"
											>&nbsp; ماه &nbsp;</label
										>
									</div>
								</div>
							</div>

							<!-- ====== instalment_amount &  total_amount_of_instalments ===========-->
							<div class="row justify-content-between">
								<!--   instalment_amount   -->
								<div class="col-md-5">
									<div>
										<label class="form__label font-size--15 font-w--500">{{
											$t("contract.instalment_amount") + "  :  "
										}}</label>
										<vue-numeric
											id="instalment_amount"
											separator=","
											v-model="instalment_amount"
											class="form-control"
											read-only
										></vue-numeric>
										<label class="form__label font-size--15 font-w--400"
											>{{ "&nbsp;" + $t("contract.rial") }} &nbsp;</label
										>
									</div>
								</div>
								<!--   total_amount_of_instalments   -->
								<div class="col-md-6">
									<div class="form-group">
										<label class="form__label font-size--15 font-w--500"
											>{{
												$t("contract.total_amount_of_instalments")
											}}
											&nbsp;:&nbsp;</label
										>
										<vue-numeric
											id="total_amount_of_instalments"
											separator=","
											v-model="total_amount_of_instalments"
											class="form-control"
											read-only
										></vue-numeric>
										<label class="form__label font-size--15 font-w--400"
											>{{ "&nbsp;" + $t("contract.rial") }} &nbsp;</label
										>
									</div>
								</div>
							</div>

							<!-- ====== instalment_start_date &  number_of_pays ===========-->
							<div class="row justify-content-between">
								<!--    instalment_start_date   -->
								<div class="col-md-6">
									<div>
										<label
											class="form__label text-uppercase font-size--15 font-w--500"
											>{{
												$t("contract.instalment_start_date")
											}}
											&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;</label
										>
										<label
											class="form__label text-uppercase font-size--15 font-w--400"
										>
											&nbsp;&nbsp;
											{{ instalment_start_date | moment("jYYYY/jMM/jD ") }}
										</label>
									</div>
								</div>
								<!--   number_of_pays   -->
								<div class="col-md-6">
									<div class="form-group">
										<label class="form__label font-size--15 font-w--500"
											>{{ $t("contract.number_of_pays") }} &nbsp;:&nbsp;</label
										>
										<label
											class="form__label text-uppercase font-size--15 font-w--400"
											>&nbsp;{{ number_of_pays }}&nbsp;</label
										>
										<label
											class="form__label text-uppercase font-size--15 font-w--400"
											>&nbsp; ماه &nbsp;</label
										>
									</div>
								</div>
							</div>

							<!-- ====== debit_amount &  total_amount_of_instalments ===========-->
							<div class="row justify-content-between ">
								<!--   debit_amount   -->
								<div class="col-md-5">
									<div>
										<label class="form__label font-size--15 font-w--500">{{
											$t("contract.debit_amount") + "  :  "
										}}</label>
										<vue-numeric
											id="debit_amount"
											separator=","
											v-model="debit_amount"
											class="form-control"
											read-only
										></vue-numeric>
										<label class="form__label font-size--15 font-w--400"
											>{{ "&nbsp;" + $t("contract.rial") }} &nbsp;</label
										>
									</div>
								</div>
								<!--   remaining_amount   -->
								<div class="col-md-6">
									<div>
										<label class="form__label font-size--15 font-w--500">{{
											$t("contract.remaining_amount") + "  :  "
										}}</label>
										<vue-numeric
											id="remaining_amount"
											separator=","
											v-model="remaining_amount"
											class="form-control"
											read-only
										></vue-numeric>
										<label class="form__label font-size--15 font-w--400"
											>{{ "&nbsp;" + $t("contract.rial") }} &nbsp;</label
										>
									</div>
								</div>
							</div>
							<br />
							<!-- ========== sign_date & end_date ===============-->
							<div class="row justify-content-between">
								<!--   sign_date   -->
								<div class="col-md-5">
									<div>
										<label class="form__label  font-size--15 font-w--500"
											>{{
												$t("contract.sign_date")
											}}
											&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;</label
										>
										<label
											class="form__label text-uppercase font-size--15 font-w--400"
										>
											&nbsp;&nbsp; {{ sign_date | moment("jYYYY/jMM/jD ") }}
										</label>
									</div>
								</div>
								<br />
								<!--   end_date   -->
								<div class="col-md-6">
									<div>
										<label
											class="form__label text-uppercase font-size--15 font-w--500"
											>{{
												$t("contract.end_date")
											}}
											&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;</label
										>
										<label
											class="form__label text-uppercase font-size--15 font-w--400"
										>
											&nbsp;&nbsp; {{ end_date | moment("jYYYY/jMM/jD ") }}
										</label>
									</div>
								</div>
							</div>
							<br />
							<!-- ========== description & status ===============-->
							<div class="row justify-content-between">
								<!--   description   -->
								<div class="col-md-6">
									<div>
										<label
											class="form__label text-uppercase font-size--15 font-w--500"
											>{{
												$t("contract.description")
											}}
											&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;</label
										>
										<label
											class="form__label text-uppercase font-size--15 font-w--400"
										>
											{{ description }}
										</label>
									</div>
								</div>

								<!--   status   -->
								<div class="col-md-6">
									<div>
										<label
											class="form__label text-uppercase font-size--15 font-w--500"
											>{{
												$t("contract.status")
											}}
											&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;</label
										>
										<label
											class="form__label text-uppercase font-size--15 font-w--400"
										>
											<span v-html="statusShow(status)"> </span>
										</label>
									</div>
								</div>
							</div>
							<br />
							<!-- ========== clearin_date & clearing_amount ===============-->
							<div class="row justify-content-between">
								<!--   clearin_date   -->
								<div class="col-md-6">
									<div>
										<label
											class="form__label text-uppercase font-size--15 font-w--500"
											>{{
												$t("contract.clearinDate")
											}}
											&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;</label
										>
										<label
											class="form__label text-uppercase font-size--15 font-w--400"
										>
											&nbsp;&nbsp; {{ clearing_date | moment("jYYYY/jMM/jD ") }}
										</label>
									</div>
								</div>

								<!--   clearing_amount   -->
								<div class="col-md-6">
									<div>
										<label
											class="form__label text-uppercase font-size--15 font-w--500"
											>{{
												$t("contract.clearingAmount")
											}}
											&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;</label
										>
										<vue-numeric
											id="clearing_amount"
											separator=","
											v-model="clearing_amount"
											class="form-control"
											read-only
										></vue-numeric>
										<label class="form__label font-size--15 font-w--400"
											>{{ "&nbsp;" + $t("contract.rial") }} &nbsp;</label
										>
									</div>
								</div>
							</div>
							<br />
							<!-- ========== vcc_number  ===============-->
							<div class="row justify-content-between">
								<!--   vcc_number   -->
								<div class="col-md-6">
									<div>
										<label
											class="form__label text-uppercase font-size--15 font-w--500"
											>{{
												$t("contract.vcc_number")
											}}
											&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;</label
										>
										<label
											class="form__label text-uppercase font-size--15 font-w--400"
										>
											{{ vcc_number }}
										</label>
									</div>
								</div>
								<!-- Pay  status   -->
								<div class="col-md-6">
									<button
										v-show="
											supplier_type && this.status === '1' && !this.is_signed
										"
										type="button"
										class="btn btn-bg--cta--1 btn-size--sm btn-hover--3d "
										data-toggle="modal"
										data-target="#creatcontract"
									>
										{{ $t("contract.createContract") }}
									</button>
								</div>
								<!-- <div class="col-md-6">
									<div>
										
										<a :href="clear_receipt" 
										class="btn btn-bg--darkblue btn-size--sm btn-hover--3d col-md-4 col-sm-8"> لینک تسویه</a>
									</div>
								</div> -->
							</div>
							<hr />
							<!-- ========== clear_receipt & final_contract  ===============-->
							<div class="row justify-content-between">
								<!-- clear_receipt -->

								<a
									v-if="this.clear_receipt"
									class="btn btn-bg--darkblue btn-size--sm btn-hover--3d col-md-5 col-sm-8"
									@click.prevent="getClearReciept"
								>
									{{ $t("contract.clearReciept") }}</a
								>

								<!-- final_contract -->

								<a
									v-if="final_c"
									class="btn btn-bg--darkblue btn-size--sm btn-hover--3d col-md-5 col-sm-8"
									@click.prevent="getFinalContract"
								>
									{{ $t("contract.finalContract") }}</a
								>
							</div>
							<br />
							<!-- ========== supplier_contract & customer_contract  ===============-->
							<div class="row justify-content-between">
								<!-- supplier_contract v-if="supplier_contract"-->

								<a
									v-if="supp_c"
									class="btn btn-bg--darkblue btn-size--sm btn-hover--3d col-md-5 col-sm-8 "
									@click.prevent="getSupplierContract"
								>
									{{ $t("contract.supplierContract") }}</a
								>

								<!-- customer_contract   v-if="customer_contract"-->

								<a
									v-if="cust_c"
									class="btn btn-bg--darkblue btn-size--sm btn-hover--3d col-md-5 col-sm-8"
									@click.prevent="getCustomerContract"
								>
									{{ $t("contract.customerContract") }}</a
								>
							</div>
						</div>

						<hr />

						<div class="row justify-content-between">
						
							<router-link
								:to="
									'/supplier/customers/' +
										this.id +
										'/instalments/' +
										this.contract_id
								"
								class="btn btn-bg--dark btn-size--sm btn-hover--3d col-md-5 col-sm-10"
								replace
							>
								<span class="font-size--13 font-w--300">
									{{ $t("contract.instalments_noteBook") }}
								</span>
							</router-link>
							
							<router-link
								:to=" '/supplier/customers/' + this.id +'/payments/' +this.contract_id"
								class="btn btn-bg--dark btn-size--sm btn-hover--3d col-md-5 col-sm-10"
								@click.prevent="updateUser"
								replace
							>
								<span class="font-size--13 font-w--300">
									{{ $t("contract.payment_noteBook") }}
								</span>
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--======================= modal ========================-->
		<div
		    
			class="modal fade"
			id="creatcontract"
			v-el:craetcontract
			tabindex="-1"
			role="dialog"
			aria-labelledby="exampleModalLabel"
			aria-hidden="true"
		>
			>
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header bg-color--darkblue--1 pr-0">
						<div class="row justify-content-between col-12 pr-0">
							<div class="col-10">
								<h5 class="modal-title text-white mr-auto" id="calculatorLable">
									عقد قرارداد
								</h5>
							</div>
							<div class="col-1 px-0">
								<button
									type="button"
									class="close  "
									data-dismiss="modal"
									aria-label="Close"
								>
									<span aria-hidden="true" class="text-white mr-auto">&times;</span>
								</button>
							</div>
						</div>
					</div>
					<div class="modal-body">
						<p>
							تاریخ عقد قرارداد برای
							<span>{{ new Date() | moment("jYYYY/jMM/jD ") }}</span>
							تنظیم شود.
						</p>
					</div>
					<div class="modal-footer bg-color--darkblue--1">
						<button
							type="button"
							class="btn btn-bg--primary mr-auto"
							data-dismiss="modal"
							@click.prevent="createContract"
						>
							تایید
						</button>
						<button
							type="button"
							class="btn btn-bg--darkblue"
							data-dismiss="modal"
						>
							بستن
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// import HeaderSuplier from "../components/shared/HeaderSuplier";
import VueNumeric from "vue-numeric";
// eslint-disable-next-line no-unused-vars
import moment from "moment";
//  var moment=require("moment")
export default {
	props: ["id", "contract_id"],
	data() {
		return {
			createContractResult:false,
			first_name: "",
			last_name: "",
			sign_date: "",
			invoice_date: "",
			description: "",
			net_amount: "",
			number_of_instalment: "",
			downpayment: "",
			status: "",
			supplier_name: "",
			// contract_id: "",
			vcc_number: "",
			customer: "",
			supplier: "",
			vcc: "",
			customer_fullname: "",
			clearing_date: "",
			instalment_amount: "",
			total_amount_of_instalments: "",
			instalment_start_date: "",
			end_date: "",
			remaining_amount: "",
			debit_amount: "",
			number_of_pays: "",
			instalment_detail: "",
			pay_status: "",
			is_signed: "",
			url: "",
			clearing_amount:"",
			
			clear_receipt: "",
			final_c: "",
			supp_c: "",
			cust_c: "",
			columns: [
				{
					label: "تاریخ پرداخت",
					field: "date",
					tdClass: "text-center",
					thClass: "text-center",
				},
				{
					label: "مقدار پرداختی",
					field: "amount",
					tdClass: "text-center",
					thClass: "text-center",
				},
				{
					label: "ما به التفاوت",
					field: "difference",
					tdClass: "text-center",
					thClass: "text-center",
				},
				{
					label: "وضعیت",
					field: "status",
					tdClass: "text-center",
					thClass: "text-center",
				},
			],
			rows: "",
		};
	},
	mounted() {
		// this.$tabs.refresh('/supplier/customers/351');
		this.showContractDetail();
		this.getSuppliersCustomer();
	},
	computed: {
		contract_identification() {
			return this.contract_id;
		},
		supplier_type() {
			return this.$store.getters.getSupplierType;
		},
	},
	methods: {
		format_date(value) {
			if (value) {
				return moment().format("YYYY-MM-DD");
			}
		},
		statusFn: function(st) {
			if (st === "0") {
				return '<span class="badge badge-warning" style="height:25px;text-align:center"><b>پرداخت با تاخیر</b></span>';
			}
			if (st === "1") {
				return '<span class="badge badge-success" style="height:25px;"><b>پرداخت به موقع</b></span>';
			}
			if (st === "2") {
				return '<span class="badge badge-danger" style="height:25px;"><b> پرداخت نشده</b></span>';
			}
			if (st === "3") {
				return '<span class="badge badge-secondary" style="height:25px;text-align:center"><b>موعد قسط نرسیده است</b></span>';
			}

			return;
		},
		actionBtn: function() {
			return '<button  @click.prevent="showContractDetail" type="button" class="btn btn-primary text-center font-w--400 " style="width:70px;height:35px;font-size: 0.75rem;">جزییات</button>';
		},
		rowStyleClassFn(row) {
			if (row.status === "0") {
				return "bg-warning";
			}
			if (row.status === "1") {
				return "bg-success";
			}
			if (row.status === "2") {
				return "bg-danger";
			}
			if (row.status === "3") {
				return "bg-light";
			}
		},
		// eslint-disable-next-line no-unused-vars
		statusShow(st) {
			if (st === "0") {
				return '<span class="badge badge-danger" style="height:25px;text-align:center"><b>تایید نشده</b></span>';
			}
			if (st === "1") {
				return '<span class="badge badge-info" style="height:25px;"><b>در حال عقد قراداد</b></span>';
			}
			if (st === "2") {
				return '<span class="badge badge-success" style="height:25px;"><b> تایید قرارداد و ارسال کالا</b></span>';
			}
			if (st === "3") {
				return '<span class="badge badge-info" style="height:25px;text-align:center"><b>تسویه با فروشگاه</b></span>';
			}
			if (st === "4") {
				return '<span class="badge badge-info" style="height:25px;"><b>پرداخت اقساط</b></span>';
			}
			if (st === "5") {
				return '<span class="badge badge-success" style="height:25px;"><b> تصفیه نهایی</b></span>';
			}
			if (st === "6") {
				return '<span class="badge badge-warning" style="height:25px;"><b> تحویل مدارک به متقاضی</b></span>';
			}
			if (st === "7") {
				return '<span class="badge badge-danger" style="height:25px;"><b>انصراف متقاضی</b></span>';
			}
		},
		payStatusShow(st) {
			if (st === "1") {
				return '<span class="badge badge-succes" style="height:25px;"><b>خوش‌ حساب</b></span>';
			}
			if (st === "2") {
				return '<span class="badge badge-warning" style="height:25px;"><b> پرداخت نا‌منظم</b></span>';
			}
			if (st === "3") {
				return '<span class="badge badge-danger" style="height:25px;text-align:center"><b>پرداخت پرخطر</b></span>';
			}
		},
		getSuppliersCustomer() {
			this.$store
				.dispatch("getSuppliersCustomer", this.id)
				.then((resp) => {
					console.log(resp);
				})
				.catch((err) => {
					console.log(err);
				});
		},
		showContractDetail() {
			// console.log("props= ", this.id);

			this.$store
				.dispatch("getSuppliersCustomerContractDetail", this.contract_id)
				.then((resp) => {
					(this.first_name = resp.body.first_name),
						(this.last_name = resp.body.last_name),
						(this.sign_date = resp.body.sign_date),
						(this.invoice_date = resp.body.invoice_date),
						(this.description = resp.body.description),
						(this.net_amount = resp.body.net_amount),
						(this.number_of_instalment = resp.body.number_of_instalment),
						(this.downpayment = resp.body.downpayment),
						(this.status = resp.body.status),
						(this.supplier_name = resp.body.supplier_name),
						// (this.contract_id = resp.body.id),
						(this.vcc_number = resp.body.vcc_number),
						(this.customer = resp.body.customer),
						(this.customer_fullname = resp.body.customer_fullname),
						(this.clearing_date = resp.body.clearing_date),
						(this.instalment_amount = resp.body.instalment_amount),
						(this.total_amount_of_instalments =
							resp.body.total_amount_of_instalments),
						(this.instalment_start_date = resp.body.instalment_start_date),
						(this.end_date = resp.body.end_date),
						(this.remaining_amount = resp.body.remaining_amount),
						(this.debit_amount = resp.body.debit_amount),
						(this.number_of_pays = resp.body.number_of_pays),
						(this.instalment_detail = resp.body.instalment_detail);
					this.pay_status = resp.body.pay_status;
					this.clear_receipt = resp.body.clear_receipt;
					this.final_c = resp.body.final_c;
					this.supp_c = resp.body.supp_c;
					this.cust_c = resp.body.cust_c;
					this.rows = resp.body.instalment_detail;
					this.is_signed = resp.body.is_signed;
					this.clearing_amount=resp.body.clearing_amount;
					// this.clearing_date=resp.body.clearing_date;
					console.log(resp);
				})
				.catch((err) => {
					console.log(err);
				});
		},
		getClearReciept() {
			let load = this.$loading.show();
			this.$store
				.dispatch("getSupplierClearReciept", this.clear_receipt)
				.then((response) => {
					this.downloadFile(response, "clear_receipt");
					console.log("response: ", response);
					load.hide();
				})
				.catch((err) => {
					console.warn("error from download_contract");
					console.log("err:  ", err);
					load.hide();
				});
		},
		getFinalContract() {
			let load = this.$loading.show();
			this.$store
				.dispatch("getFinalContract", this.final_c)
				.then((response) => {
					this.downloadFile(response, "final_c");
					console.log("response: ", response);
					load.hide();
				})
				.catch((err) => {
					console.warn("error from download_contract");
					console.log("err:  ", err);
					load.hide();
				});
		},
		getSupplierContract() {
			let load = this.$loading.show();
			this.$store
				.dispatch("getSupplierContract", this.supp_c)
				.then((response) => {
					this.downloadFile(response, "supp_c");
					console.log("response: ", response);
					load.hide();
				})
				.catch((err) => {
					console.warn("error from download_contract");
					console.log("err:  ", err);
					load.hide();
				});
		},
		getCustomerContract() {
			let load = this.$loading.show();
			this.$store
				.dispatch("getSupplierCustomerContract", this.cust_c)
				.then((response) => {
					this.downloadFile(response, "cust_c");
					console.log("response: ", response);
					load.hide();
				})
				.catch((err) => {
					console.warn("error from download_contract");
					console.log("err:  ", err);
					load.hide();
				});
		},
		downloadFile(response, filename) {
			// It is necessary to create a new blob object with mime-type explicitly set
			// otherwise only Chrome works like it should
			var newBlob = new Blob([response.body], { type: "application/pdf" });

			// IE doesn't allow using a blob object directly as link href
			// instead it is necessary to use msSaveOrOpenBlob
			if (window.navigator && window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(newBlob);
				return;
			}

			// For other browsers:
			// Create a link pointing to the ObjectURL containing the blob.
			const data = window.URL.createObjectURL(newBlob);
			var link = document.createElement("a");
			link.href = data;
			link.download = filename + ".pdf";
			link.click();
			setTimeout(function() {
				// For Firefox it is necessary to delay revoking the ObjectURL
				window.URL.revokeObjectURL(data);
			}, 100);
		},
		createContract() {
			let load = this.$loading.show();
			let date = this.format_date(new Date());
			console.log("date: " + date);
			// let contract_data = {
			// 	sign_date: "2021-03-05"
			// };
			// let contract_data = { sign_date: "2021-03-05" };
			this.$store
				.dispatch("updateSupplierContract", {
					contract_id: this.contract_id,
					data: { sign_date: date },
				})
				.then((response) => {
					console.log("response: ", response);
					this.createContractResult = true
					this.$noty.success("قرارداد با موفقیت تشکیل شد");
					// document.getElementById("craetcontract").modal("toggle");
					this.$tabs.refresh()
					load.hide();
				})
				.catch((err) => {
					console.log("err:  ", err);
					this.$noty.error("مشکلی در ایجاد قرارداد به وجود آمده است");
					load.hide();
				});
		},
	},
	components: {
		VueNumeric,
	},
};
</script>

<style>
.green {
	background-color: green;
}

.red {
	background-color: red;
}
</style>
